import * as angular from 'angular';
import { BrowserModule } from '@angular/platform-browser';
import { CheckboxModule } from 'primeng/checkbox';
import { ClickOutsideModule } from 'ng-click-outside';
import { CommonModule } from '@angular/common';
import { DashboardComponents, DashboardServices } from './index';
import { TestModule } from './test/test.module';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MatMenuModule } from '@angular/material/menu';
import { NgModule } from '@angular/core';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SharedModule as PNGShared } from 'primeng/api';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../layout/layout.module';
import { DropdownWithTitleModule } from './dropdown_with_title/dropdown-with-title.module';
import { advancedSearchReducer } from './store/advanced-search.reducer';
import { UserModule } from '../user/user.module';
import { CoreModule } from '../core/core.module';
import { WorklistModule } from '../worklist/worklist.module';
import { NavigationModule } from './navigation/navigation.module';
import { ExportModule } from '../export/export.module';
import { DisclaimerViewerModule } from '@ispm/dashboard/disclaimer-viewer/disclaimer-viewer.module';
import { AggregatorModule } from "@ispm-client/modules/aggregator/aggregator.module";
import { DashboardMenuModule } from "@ispm/dashboard/menu/menu.module";
import { DiagnosticOrderService } from './test/services/diagnostic-order.service';
import { PathHomeComponent } from '@ispm/migration/components/path-home/path-home.component';
import { AttachmentService } from '@ispm/migration/services/attachment.service';
import { AboutBoxComponent } from '@ispm/migration/components/about-box/about-box.component';
import { DlsSharedModule } from "../dls-shared.module";
import { StoreModule } from "@ngrx/store";

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    DlsSharedModule,
    SharedModule,
    LayoutModule,
    PNGShared,
    NavigationModule,
    TestModule,
    ClickOutsideModule,
    DropdownWithTitleModule,
    UserModule,
    EditorModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    NoopAnimationsModule,
    StoreModule.forFeature('advancedSearch', advancedSearchReducer),
    DropdownModule,
    InputSwitchModule,
    CheckboxModule,
    OverlayPanelModule,
    DialogModule,
    ExportModule,
    DisclaimerViewerModule,
    AggregatorModule,
    DashboardMenuModule,
    BrowserModule,
    WorklistModule,
  ],
  declarations: [...DashboardComponents, AboutBoxComponent, PathHomeComponent],
  exports: [...DashboardComponents],
  providers: [...DashboardServices,
    DiagnosticOrderService, AttachmentService
  ]
})
export class DashboardModule {
}
